import React from 'react';
import { cn } from '@/shared/lib/utils';

interface KPIProgressValueProps {
  currentProgress: number;
  quantity: number;
  unit: string;
  variant?: 'inline' | 'badge';
  isCompleted?: boolean;
  className?: string;
}

export const KPIProgressValue: React.FC<KPIProgressValueProps> = ({
  currentProgress,
  quantity,
  unit,
  variant = 'inline',
  isCompleted = false,
  className,
}) => {
  if (variant === 'inline') {
    return (
      <span className={cn('text-xs text-gray-500 font-medium', className)}>
        <span>{currentProgress}</span>/
        <span>
          {quantity} {unit}
        </span>
      </span>
    );
  }

  // Badge variant
  return (
    <div
      className={cn(
        'flex-shrink-0 px-2.5 py-1 rounded-md text-xs font-medium',
        isCompleted
          ? 'bg-emerald-100 text-emerald-700'
          : 'bg-gray-100 text-gray-700',
        className
      )}
    >
      <span>{currentProgress}</span>/
      <span>
        {quantity} {unit}
      </span>
    </div>
  );
};
